module.exports = __webpack_public_path__ + "static/media/harshad.ee9626f1.jpeg";